export default __webpack_public_path__ + "static/media/play_store2.547ed951.svg";